'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Divider = require('./Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _SortableList = require('./SortableList');

var _SortableList2 = _interopRequireDefault(_SortableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_ListProps = {
  /**
   * The content of List
   */
  children: require('prop-types').any,

  /**
   * If `true`, a 1px border is added to the bottom of each list item.
   */
  divider: require('prop-types').bool,

  /**
   * If `true`, it should be the expansion list
   */
  expansion: require('prop-types').bool,
  draggable: require('prop-types').bool,
  dragIcon: typeof Node === 'function' ? require('prop-types').instanceOf(Node) : require('prop-types').any,

  /**
   * If `true`, the left and right padding is removed from all list items
   */
  disableAllGutters: require('prop-types').bool,

  /**
   * If `true`, the border will be removed from the list
   */
  disableBorder: require('prop-types').bool,
  onStart: require('prop-types').func,
  onMove: require('prop-types').func,
  onEnd: require('prop-types').func
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_ListProps', {
  value: babelPluginFlowReactPropTypes_proptype_ListProps,
  configurable: true
});

var List = function (_Component) {
  _inherits(List, _Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.renderChildren = function (divider, items) {
      //output items
      var results = [],
          hasSubheader = false;
      var renderChildren = _this.renderChildren;
      items.map(function (item, index) {
        if (!item) {
          return;
        }
        if (item instanceof Array) {
          results = [].concat(_toConsumableArray(results), _toConsumableArray(renderChildren(divider, item)));
        } else {
          results.push(item);
          /**
           * Add Divider after each listitem except subheader
           */
          if (divider && index !== items.length - 1 && (!item.props || !item.props.subHeader) && !items[index + 1].props.subHeader) {
            results.push(_react2.default.createElement(_Divider2.default, { key: 'divider-' + index }));
          }

          if (item.props && item.props.subHeader) {
            hasSubheader = true;
          }
        }
      });
      return {
        hasSubheader: hasSubheader,
        content: results
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _ClassNames;

      var _props = this.props,
          style = _props.style,
          className = _props.className,
          disableBorder = _props.disableBorder,
          disableAllGutters = _props.disableAllGutters,
          divider = _props.divider,
          children = _props.children,
          expansion = _props.expansion,
          _props$draggable = _props.draggable,
          draggable = _props$draggable === undefined ? false : _props$draggable,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'disableBorder', 'disableAllGutters', 'divider', 'children', 'expansion', 'draggable']);

      var renderChildren = this.renderChildren;


      var items = children ? Array.isArray(children) ? children : [children] : [];

      var childrenInfo = renderChildren(divider, items);

      var classes = (0, _classnames2.default)(className, 'a-list', (_ClassNames = {
        'no-border': disableBorder,
        'with-divider': divider
      }, _defineProperty(_ClassNames, 'disable-all-gutters', disableAllGutters), _defineProperty(_ClassNames, 'expansion-list', expansion), _defineProperty(_ClassNames, 'drag-list', draggable), _defineProperty(_ClassNames, 'drag-with-handle', this.props.dragIcon), _ClassNames));

      if (draggable) {
        var sortableProps = _extends({
          children: children
        }, otherProps);
        return _react2.default.createElement(_SortableList2.default, Object.assign({}, sortableProps, {
          style: style,
          items: items,
          className: classes
        }));
      } else {
        classes = (0, _classnames2.default)(classes, {
          'with-subheader': childrenInfo.hasSubheader
        });
        return _react2.default.createElement(
          'ul',
          Object.assign({ style: style, className: classes }, otherProps),
          childrenInfo.content
        );
      }
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  disableBorder: _propTypes2.default.bool,
  disableAllGutters: _propTypes2.default.bool,
  divider: _propTypes2.default.bool,
  expansion: _propTypes2.default.bool,
  draggable: _propTypes2.default.bool,
  children: _propTypes2.default.any,
  onStart: _propTypes2.default.func,
  onMove: _propTypes2.default.func,
  onEnd: _propTypes2.default.func
};

List.displayName = 'List';

exports.default = List;